import React from 'react';
import { makeStyles } from '@mui/styles';
import { InputLabelProps, useTheme } from '@mui/material';
import { HwtButton } from './@common/Buttons/HwtButton';

const useStyles = theme =>
  makeStyles(() => ({
    root: () => ({
      '& > *': {
        margin: theme.spacing(1)
      }
    }),
    input: {
      display: 'none !important'
    }
  }));

type Props =
  | {
      children: any;
      btnClass: string;
      onChange: () => void;
      ButtonComponent: React.FC<any>;
      labelProps: InputLabelProps;
      accept: string;
    }
  | any;

export default function FileUploadButton({
  children,
  btnClass,
  onChange,
  ButtonComponent,
  labelProps,
  accept = 'audio/*',
  ...props
}: Props) {
  const theme = useTheme();
  const classes = useStyles(theme)();

  const BtnComponent = ({ children }) => {
    return ButtonComponent ? (
      <ButtonComponent
        {...props}
        component="span"
        className={btnClass}
        style={{ marginBottom: '15px', textTransform: 'none', padding: 0 }}
      >
        {children}
      </ButtonComponent>
    ) : (
      <HwtButton
        {...props}
        component="span"
        className={btnClass}
        variant="outlined"
        style={{
          marginBottom: '15px',
          padding: 0,
          width: '243px'
        }}
      >
        {children}
      </HwtButton>
    );
  };

  return (
    <>
      <input
        accept={accept}
        className={classes.input}
        id="contained-button-file"
        type="file"
        onChange={onChange}
        value={props.value}
        name={props.name}
      />
      <label htmlFor="contained-button-file" {...labelProps}>
        <BtnComponent>{children}</BtnComponent>
      </label>
    </>
  );
}
